import { CommonModule } from '@angular/common';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class FundamentalChartModule {
}
FundamentalChartModule.ɵfac = function FundamentalChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundamentalChartModule)(); };
FundamentalChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundamentalChartModule });
FundamentalChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ChartsSharedModule, CommonModule, DisabledModule, FeatureNeededModule, IconModule, TooltipModule] });
